<!-- 开始做题 -->
<template>
    <div class="StartTheTopic">
        <div class="subjectBox">
            <div class="title">{{currentSubjectStr}}</div>
            <div class="changeBox">
                <div class="btn" @click="changeSubject" @mouseleave="mouseleaveChangeSubject" @mouseenter="mouseenterChangeSubject">
                    <img :src="!mouseChange ? require('@/common/images/personal/change.svg') : require('@/common/images/personal/change2.svg')" alt="">
                    切换科目
                </div>
            </div>
            <div class="changeListBox" :class="{'showlistBox': showlistBox}" @mouseenter="mouseenterListBox" @mouseleave="mouseoutListBox">
                <div class="codeList">
                    <div class="innerBox">
                        <div class="item" @mouseenter="codeMouseenter(index)" :class="{'active': item.code === currentSubjectObj.code}" v-for="(item, index) in topicQuesBankConfiguration" :key="index">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="listBox">
                    <div class="innerBox">
                        <div :class="{'item': true, 'active': currentSubjectcodeId === item.id}" @click="selectSubject(item, index)" v-for="(item, index) in currentSubjectObj.subjectcode" :key="index">
                            {{currentSubjectObj.name}}-{{item.name}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="clock_in">
                <img @click="openClockIn" :src="require('@/common/images/personal/clock_in.png')" alt="">    
            </div>
        </div>
        <div class="menuBox">
            <div :class="{'menuItem': true, 'menuItemActive': active === index}" v-for="(item, index) in menulist" :key="index" @click="changeList(index)">
                <div class="box">
                    <div :class="{'imgBox': true, 'show': active === index}">
                        <div class="img1"><img :src="item.iconActive" alt=""></div>
                        <div class="img"><img :src="item.icon" alt=""></div>
                    </div>
                </div>
                <p :class="{'title': true, 'active': active === index}">{{item.name}}</p>
            </div>
        </div>
        <!-- 章节练习 -->
        <div class="datatype1" v-if="active === 0">
            <div class="titleBox">
                <div class="left">章节</div>
                <div class="right">
                    <div class="accuracy">正确率</div>
                    <div class="count">已做/总题</div>
                </div>
            </div>
            <el-collapse class="outside" v-model="chapterPractice.activeNames" @change="activeNamesChange">
                <el-collapse-item class="outsideItem" :name="index" v-for="(item, index) in chapterPractice.bankinfolist" :key="index">
                    <template slot="title">
                        <div class="itemTitle">
                            <img :src="chapterPractice.activeNames.indexOf(index) === -1 ? require('@/common/images/personal/pack_up.svg') : require('@/common/images/personal/unfold.svg')" alt="">
                            {{item.sectionname}}
                        </div>
                    </template>
                    <div v-for="(obj, i) in item.taskinfolist" :key="i">
                        <el-collapse class="inside" v-model="item.activeNames" @change="activeNamesItemChange(index, i)">
                            <el-collapse-item :name="i">
                                <template slot="title">
                                    <div class="itemTitle">
                                        <div class="left">
                                            <img v-if="obj.childrenlist.length" :src="item.activeNames.indexOf(i) === -1 ? require('@/common/images/personal/pack_up.svg') : require('@/common/images/personal/unfold.svg')" alt="">
                                            <span :class="{'childrenlist': obj.childrenlist.length, 'taskname': !obj.childrenlist.length}">{{obj.taskname}}</span>
                                        </div>
                                        <div class="right" v-if="obj.exampaperinnerid">
                                            <div class="accuracy">{{obj.rightrate}}</div>
                                            <div class="count">{{obj.finishquescount}}/{{obj.quescount}}</div>
                                            <div class="btn">
                                                <div v-if="obj.userexamstatus === 0" class="doExercise" @click.stop="updateStartExam(obj)">做题</div>
                                                <div v-if="obj.userexamstatus === 1" class="continue" @click.stop="updateStartExam(obj)">继续</div>
                                                <div v-if="obj.userexamstatus === 10" class="doExercise" @click.stop="updateStartExam(obj)">重做</div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div class="subjectItem" v-for="(options, j) in obj.childrenlist" :key="j">
                                    <div class="taskname">{{options.taskname}}</div>
                                    <div class="right" v-if="options.exampaperinnerid">
                                        <div class="accuracy">{{options.rightrate}}</div>
                                        <div class="count">{{options.finishquescount}}/{{options.quescount}}</div>
                                        <div class="btn">
                                            <div v-if="options.userexamstatus === 0" class="doExercise" @click="updateStartExam(options)">做题</div>
                                            <div v-if="options.userexamstatus === 1" class="continue" @click="updateStartExam(options)">继续</div>
                                            <div v-if="options.userexamstatus === 10" class="doExercise" @click="updateStartExam(options)">重做</div>
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <!-- 历年真题 -->
        <div class="datatype2" v-else-if="active === 1">
            <div class="" v-if="previousExamPapers.quesbanklist.length">
                <div class="item" v-for="(item, index) in previousExamPapers.quesbanklist" :key="index">
                    <div class="leftMsg">
                        <div class="img"><img :src="require('@/common/images/personal/test_paper.svg')" alt=""></div>
                        <div class="textBox">
                            <div class="name">{{item.bankname}}</div>
                            <div class="count">
                                <span class="examcount">{{item.examcount}}人参考</span>
                                <span class="quescount">共{{item.quescount}}题</span>
                            </div>
                        </div>
                    </div>
                    <div class="rightBtn">
                        <div class="continue" v-if="item.userexamstatus === 1" @click="updateStartExam(item)">继续做题</div>
                        <div class="doExercise" v-else-if="item.userexamstatus === 10" @click="updateStartExam(item)">重新做题</div>
                        <div class="doExercise" v-else-if="item.userexamstatus === 0" @click="updateStartExam(item)">开始做题</div>
                    </div>
                </div>
                <Page @currentChange="page1Change" :page="page1" />
            </div>
            <div class="noData" v-else>
                <img :src="require('@/common/images/gujing/null.png')" alt="">
                <p>当前暂无历年真题</p>
            </div>
        </div>
        <!-- 模拟试题 -->
        <div class="datatype2" v-else-if="active === 2">
            <div class="" v-if="mockTest.quesbanklist.length">
                <div class="item" v-for="(item, index) in mockTest.quesbanklist" :key="index">
                    <div class="leftMsg">
                        <div class="img"><img :src="require('@/common/images/personal/test_paper.svg')" alt=""></div>
                        <div class="textBox">
                            <div class="name">{{item.bankname}}</div>
                            <div class="count">
                                <span class="examcount">{{item.examcount}}人参考</span>
                                <span class="quescount">共{{item.quescount}}题</span>
                            </div>
                        </div>
                    </div>
                    <div class="rightBtn">
                        <div class="continue" v-if="item.userexamstatus === 1" @click="updateStartExam(item)">继续做题</div>
                        <div class="doExercise" v-else-if="item.userexamstatus === 10" @click="updateStartExam(item)">重新做题</div>
                        <div class="doExercise" v-else-if="item.userexamstatus === 0" @click="updateStartExam(item)">开始做题</div>
                    </div>
                </div>
                <Page @currentChange="page2Change" :page="page2" />
            </div>
            <div class="noData" v-else>
                <img :src="require('@/common/images/gujing/null.png')" alt="">
                <p>当前暂无模拟试题</p>
            </div>
        </div>
        <!-- 易错题 -->
        <div class="datatype1" v-else-if="active === 3">
            <div class="titleBox">
                <div class="left">章节</div>
                <div class="right">
                    <div class="accuracy">正确率</div>
                    <div class="count">已做/总题</div>
                </div>
            </div>
            <el-collapse class="outside" v-model="easyWrongTopic.activeNames" @change="activeNamesChange">
                <el-collapse-item class="outsideItem" :name="index" v-for="(item, index) in easyWrongTopic.bankinfolist" :key="index">
                    <template slot="title">
                        <div class="itemTitle">
                            <img :src="easyWrongTopic.activeNames.indexOf(index) === -1 ? require('@/common/images/personal/pack_up.svg') : require('@/common/images/personal/unfold.svg')" alt="">
                            {{item.sectionname}}
                        </div>
                    </template>
                    <div v-for="(obj, i) in item.taskinfolist" :key="i">
                        <el-collapse class="inside" v-model="item.activeNames">
                            <el-collapse-item :name="i">
                                <template slot="title">
                                    <div class="itemTitle">
                                        <div class="left">
                                            <img v-if="obj.childrenlist.length" :src="item.activeNames.indexOf(i) === -1 ? require('@/common/images/personal/pack_up.svg') : require('@/common/images/personal/unfold.svg')" alt="">
                                            <span :class="{'childrenlist': obj.childrenlist.length, 'taskname': !obj.childrenlist.length}">{{obj.taskname}}</span>
                                        </div>
                                        <div class="right" v-if="obj.exampaperinnerid">
                                            <div class="accuracy">{{obj.rightrate}}</div>
                                            <div class="count">{{obj.finishquescount}}/{{obj.quescount}}</div>
                                            <div class="btn">
                                                <div v-if="obj.userexamstatus === 0" class="doExercise" @click.stop="updateStartExam(obj)">做题</div>
                                                <div v-if="obj.userexamstatus === 1" class="continue" @click.stop="updateStartExam(obj)">继续</div>
                                                <div v-if="obj.userexamstatus === 10" class="doExercise" @click.stop="updateStartExam(obj)">重做</div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div class="subjectItem" v-for="(options, j) in obj.childrenlist" :key="j">
                                    <div class="taskname">{{options.taskname}}</div>
                                    <div class="right" v-if="options.exampaperinnerid">
                                        <div class="accuracy">{{options.rightrate}}</div>
                                        <div class="count">{{options.finishquescount}}/{{options.quescount}}</div>
                                        <div class="btn">
                                            <div v-if="options.userexamstatus === 0" class="doExercise" @click="updateStartExam(options)">做题</div>
                                            <div v-if="options.userexamstatus === 1" class="continue" @click="updateStartExam(options)">继续</div>
                                            <div v-if="options.userexamstatus === 10" class="doExercise" @click="updateStartExam(options)">重做</div>
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <!-- 做题记录 -->
        <div class="datatype3" v-else-if="active === 4">
            <div v-if="recordToSolveTheProblem.content.length">
                <div class="item" v-for="(item, index) in recordToSolveTheProblem.content" :key="index">
                    <div class="leftMsg">
                        <div class="typeName">
                            <div class="type" v-if="item.topicsectionname">[{{item.topicsectionname}}]</div>
                            <div class="name">{{item.exampapername}}</div>
                        </div>
                        <div class="timeCount">
                            <span class="time">{{item.datetime}}</span>
                            <span class="count">总{{item.quescount}}题/对{{item.finalrightcount}}题</span>
                        </div> 
                    </div>
                    <div class="rightBtn">
                        <div class="text check" v-if="item.examstatus === 10" @click="checkAnalysis(item)">查看解析</div>
                        <div class="text" v-else-if="item.examstatus === 1">未完成</div>
                        <div class="continue" v-if="item.examstatus === 1" @click="updateStartExam(item)">继续做题</div>
                        <div class="doExercise" v-else-if="item.examstatus === 10" @click="updateStartExam(item)">重新做题</div>
                    </div>
                </div>
                <Page @currentChange="page3Change" :page="page3" />
            </div>
            <div class="noData" v-else>
                <img :src="require('@/common/images/gujing/null.png')" alt="">
                <p>当前暂无做题记录</p>
            </div>
        </div>
        <clockIn ref="clockIn" :examcode="this.currentSubjectObj.code" />
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getTopicQuesBankInfo, updateStartExam, getTopicUserExamList} from 'api/questionbank'
import Page from '../../components/page'
import clockIn from '../../components/clockIn'
export default {
    data() {
        return {
            mouseChange: false,
            params: {
                code: this.$route.query.code ? this.$route.query.code : '',
                subjectcode: this.$route.query.subjectcode ? this.$route.query.subjectcode : ''
            },
            currentSubjectObj: {
                code: '',
                name: '',
                subjectcode: ''
            },
            currentSubjectStr: '',
            currentSubjectcode: '',
            currentSubjectcodeId: '',
            sectioncode: '',
            showlistBox: false,
            changeShowlistBox: null,
            active: 0,
            menulist: [
                {name: '章节练习', icon: require('@/common/images/personal/chapter_practice.svg'), iconActive: require('@/common/images/personal/chapter_practice_active.svg')},
                {name: '历年真题', icon: require('@/common/images/personal/previous_exam_papers.svg'), iconActive: require('@/common/images/personal/previous_exam_papers_active.svg')},
                {name: '模拟试题', icon: require('@/common/images/personal/mock_test.svg'), iconActive: require('@/common/images/personal/mock_test_active.svg')},
                {name: '易错题', icon: require('@/common/images/personal/easy_wrong_topic.svg'), iconActive: require('@/common/images/personal/easy_wrong_topic_active.svg')},
                {name: '做题记录', icon: require('@/common/images/personal/record_to_solvet_the_problem.svg'), iconActive: require('@/common/images/personal/record_to_solvet_the_problem_active.svg')},
            ],
            chapterPractice: { // 章节练习
                bankid: '',
                bankinfolist: [],
                datatype: ''
            },
            activeNames: [0],
            activeNames2: [0],
            page1: {
                page: 1,
                pagesize: 10,
                total: 0
            },
            page2: {
                page: 1,
                pagesize: 10,
                total: 0
            },
            page3: {
                page: 1,
                pagesize: 10,
                total: 0
            },
            previousExamPapers: { // 历年真题
                datatype: 2,
                pageinfo: {},
                quesbanklist: []
            },
            mockTest: { // 模拟试题
                datatype: 2,
                pageinfo: {},
                quesbanklist: []
            },
            easyWrongTopic: { // 易错题
                bankid: '',
                bankinfolist: [],
                datatype: ''
            },
            recordToSolveTheProblem: {
                content: [],
                pageinfo: {}
            },
            hoverIndex: 0
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (this.$route.query.active) {
            this.active = Number(this.$route.query.active)
        }
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'QuestionList'
            })
            return
        }
        if (this.params.code) {
            this.topicQuesBankConfiguration.some((item, index) => {
                if (this.params.code === item.code) {
                    this.currentSubjectObj = {
                        code: item.code,
                        name: item.name,
                        subjectcode: item.subjectcode
                    }
                    this.hoverIndex = index
                    if (this.params.subjectcode) {
                        item.subjectcode.some((obj) => {
                            if (obj.id === this.params.subjectcode) {
                                this.currentSubjectcodeId = obj.id
                                this.currentSubjectStr = this.currentSubjectObj.name + '-' + obj.name
                                this.currentSubjectcode = this.currentSubjectObj.code
                                return true
                            }
                        })
                    } else {
                        this.currentSubjectcodeId = item.subjectcode[0].id
                        this.currentSubjectStr = this.currentSubjectObj.name + '-' + item.subjectcode[0].name
                        this.currentSubjectcode = this.currentSubjectObj.code
                    }
                    return true
                }
            })
        } else {
            this.currentSubjectObj = {
                code: this.topicQuesBankConfiguration[0].code,
                name: this.topicQuesBankConfiguration[0].name,
                subjectcode: this.topicQuesBankConfiguration[0].subjectcode
            }
            this.hoverIndex = 0
            this.currentSubjectcodeId = this.currentSubjectObj.subjectcode[0].id
            this.currentSubjectStr = this.currentSubjectObj.name + '-' + this.currentSubjectObj.subjectcode[0].name
            this.currentSubjectcode = this.currentSubjectObj.code
            this.params.code = this.currentSubjectObj.code
            this.params.subjectcode = this.currentSubjectObj.subjectcode[0].id
        }
        this.sectioncode = this.topicQuesBankSectionConfiguration[0].code
        if (this.active < 4) {
            this.getTopicQuesBankInfo(this.active)
        } else {
            this.getTopicUserExamList()
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        openClockIn() {
            this.$refs.clockIn.open()
        },
        codeMouseenter(index) {
            this.currentSubjectObj.subjectcode = this.topicQuesBankConfiguration[index].subjectcode
            this.currentSubjectObj.name = this.topicQuesBankConfiguration[index].name
            this.hoverIndex = index
        },
        mouseenterChangeSubject() {
            if (this.changeShowlistBox) {
                clearTimeout(this.changeShowlistBox)
            }
            this.mouseChange = true
        },
        mouseleaveChangeSubject() {
            this.mouseChange = false
        },
        // 提交开始考试操作(入库相关考试信息)
        updateStartExam(item) {
            if (!this.user.isLogin) {
                this.setLoginPop(true)
                return
            }
            let params = {
                assetinnerid: '',
                taskid: '',
                examid: '',
                topiccode:this.currentSubjectObj.code
            }
            if (this.active === 0) {
                params = {
                    assetinnerid: this.chapterPractice.bankid,
                    taskid: item.taskid,
                    examid: item.userexamid,
                    topiccode:this.currentSubjectObj.code
                }
            } else if (this.active === 1) {
                params = {
                    assetinnerid: item.bankid,
                    taskid: '0',
                    examid: item.userexamid,
                    topiccode:this.currentSubjectObj.code
                }
            } else if (this.active === 2) {
                params = {
                    assetinnerid: item.bankid,
                    taskid: '0',
                    examid: item.userexamid,
                    topiccode:this.currentSubjectObj.code
                }
            } else if (this.active === 3) {
                params = {
                    assetinnerid: this.easyWrongTopic.bankid,
                    taskid: item.taskid,
                    examid: item.userexamid,
                    topiccode:this.currentSubjectObj.code
                }
            } else if (this.active === 4) {
                console.log(item)
                params = {
                    assetinnerid: item.bankid,
                    taskid: item.qbtype === 2 ? item.taskid : '0',
                    examid: item.examstatus === 10 ? '' : item.examid,
                    topiccode:this.currentSubjectObj.code
                }
            }
            console.log(item, params)
            if (!params.examid) {
                this.setLoading(true)
                updateStartExam({
                    data: params,
                    success: res => {
                        this.setLoading(false)
                        console.log(res)
                        // window.open(`localhost:6002/testPaper/examinationInterface?examid=${res.data}&bankid=${params.bankid}&token=${this.user.loginToken}`)
                        window.open(`${this.domainlist.url_course}/testPaper/examinationInterface?examid=${res.data}&bankid=${params.assetinnerid}&token=${this.user.loginToken}`)
                        if (this.active === 1 || this.active === 2) {
                            // if (item.userexamstatus === 0) {
                                item.examcount = item.examcount + 1
                            // }
                        }
                        item.userexamstatus = 1
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            } else {
                console.log(params.bankid)
                // window.open(`localhost:6002/testPaper/testPaper/examinationInterface?examid=${params.userexamid}&bankid=${params.bankid}&token=${this.user.loginToken}`)
                window.open(`${this.domainlist.url_course}/testPaper/examinationInterface?examid=${params.examid}&bankid=${params.assetinnerid}&token=${this.user.loginToken}`)
            }
        },
        // 查看解析
        checkAnalysis(item) {
            window.open(`${this.domainlist.url_course}/testPaper/viewingResults?examid=${item.examid}&bankid=${item.exampaperinnerid}&token=${this.user.loginToken}&page=1`)
        },
        // 获取题库信息
        getTopicQuesBankInfo(index) {
            let params = {}
            if (index === 0) {
                params = {
                    examcode: this.currentSubjectObj.code,
                    subjectcode: this.currentSubjectcodeId,
                    sectioncode: this.sectioncode,
                    page: 0,
                    pagesize: 0
                }
            } else if (index === 1) {
                params = {
                    examcode: this.currentSubjectObj.code,
                    subjectcode: this.currentSubjectcodeId,
                    sectioncode: this.sectioncode,
                    page: this.page1.page,
                    pagesize: this.page1.pagesize
                }
            } else if (index === 2) {
                params = {
                    examcode: this.currentSubjectObj.code,
                    subjectcode: this.currentSubjectcodeId,
                    sectioncode: this.sectioncode,
                    page: this.page2.page,
                    pagesize: this.page2.pagesize
                }
            } else if (index === 3) {
                params = {
                    examcode: this.currentSubjectObj.code,
                    subjectcode: this.currentSubjectcodeId,
                    sectioncode: this.sectioncode,
                    page: this.page3.page,
                    pagesize: this.page3.pagesize
                }
            }
            console.log(params)
            this.setLoading(true)
            getTopicQuesBankInfo({
                data: params,
                success: res => {
                    this.setLoading(false)
                    if (index === 0) {
                        res.data.bankinfolist.forEach((obj) => {
                            obj.activeNames = []
                        })
                        res.data.activeNames = [0]
                        this.chapterPractice = res.data
                    } else if (index === 1) {
                        this.previousExamPapers = res.data
                        this.page1.total = res.data.pageinfo.rowCount
                        console.log(res)
                    } else if (index === 2) {
                        // res.data.quesbanklist.forEach((obj) => {
                        //     obj.activeNames = []
                        // })
                        this.mockTest = res.data
                        this.page2.total = res.data.pageinfo.rowCount
                        console.log(res)
                    } else if (index === 3) {
                        res.data.activeNames = [0]
                        this.easyWrongTopic = res.data
                    }
                    this.active = index
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        page1Change() {
            this.getTopicQuesBankInfo(this.active)
        },
        page2Change() {
            this.getTopicQuesBankInfo(this.active)
        },
        page3Change() {
            this.getTopicUserExamList(this.active)
        },
        changeSubject() {
            this.showlistBox = true
            const that = this
            this.changeShowlistBox = setTimeout(function() {
                that.showlistBox = false
            }, 1000)
        },
        mouseoutListBox() {
            const that = this
            console.log(this.hoverIndex)
            that.topicQuesBankConfiguration.some((item, index) => {
            if (that.params.code === item.code) {
                    that.currentSubjectObj.subjectcode = item.subjectcode
                    that.currentSubjectObj.code = item.code
                    that.currentSubjectObj.name = item.name
                    that.hoverIndex = index
                }
            })
            this.changeShowlistBox = setTimeout(function() {
                that.showlistBox = false
            }, 1000)
        },
        mouseenterListBox() {
            this.showlistBox = true
            if (this.changeShowlistBox) {
                clearTimeout(this.changeShowlistBox)
            }
        },
        selectSubject(item, index) {
            // this.currentSubjectObj.code = this.topicQuesBankConfiguration[0].code
            // this.currentSubjectObj.name = this.topicQuesBankConfiguration[0].name
            // this.currentSubjectObj.subjectcode = this.topicQuesBankConfiguration[0].subjectcode
            this.currentSubjectcodeId = this.currentSubjectObj.subjectcode[index].id
            this.topicQuesBankConfiguration.some((o) => {
                let flag = false
                o.subjectcode.some((obj) => {
                    if (obj.id === item.id) {
                        this.currentSubjectObj.code = o.code
                        flag = true
                        return
                    }
                })
                if (flag) {
                   return true
                }
            })
            // this.currentSubjectObj.code = this.topicQuesBankConfiguration[this.hoverIndex].code
            console.log(item, index)
            this.params.code = this.currentSubjectObj.code
            this.currentSubjectStr = this.currentSubjectObj.name + '-' + this.currentSubjectObj.subjectcode[index].name
            this.sectioncode = '0101'
            this.active = 0
            this.showlistBox = false
            this.chapterPractice = {
                bankid: '',
                bankinfolist: [],
                datatype: ''
            }
            this.previousExamPapers = {
                datatype: 2,
                pageinfo: {},
                quesbanklist: []
            }
            this.mockTest = {
                datatype: 2,
                pageinfo: {},
                quesbanklist: []
            }
            this.easyWrongTopic = {
                bankid: '',
                bankinfolist: [],
                datatype: ''
            }
            this.recordToSolveTheProblem = {
                content: [],
                pageinfo: {}
            }
            this.page1.page = 1
            this.page2.page = 1
            this.page3.page = 1
            this.getTopicQuesBankInfo(0)
            console.log(this.currentSubjectcodeId, this.currentSubjectStr)
        },
        changeList(index) {
            // this.active = index
            console.log(index)
            if (index < 4) {
                this.sectioncode = this.topicQuesBankSectionConfiguration[index].code
                if (index === 0 && (!this.chapterPractice.bankinfolist.length || !this.chapterPractice.bankid)) {
                    this.getTopicQuesBankInfo(index)
                } else if (index === 1 && !this.previousExamPapers.quesbanklist.length) {
                    this.getTopicQuesBankInfo(index)
                } else if (index === 2 && !this.mockTest.quesbanklist.length) {
                    this.getTopicQuesBankInfo(index)
                } else if (index === 3 && (!this.easyWrongTopic.bankinfolist.length || !this.easyWrongTopic.bankid)) {
                    this.getTopicQuesBankInfo(index)
                } else {
                    this.active = index
                }
            } else {
                if (index === 4 && !this.recordToSolveTheProblem.content.length) {
                    this.getTopicUserExamList()
                } else {
                    this.active = index
                }
            }
        },
        getTopicUserExamList() {
            if (!this.user.isLogin) {
                this.setLoginPop(true)
                return
            }
            const params = {
                examcode: this.currentSubjectObj.code,
                subjectcode: this.currentSubjectcodeId,
                page: this.page3.page,
                pagesize: this.page3.pagesize
            }
            this.setLoading(true)
            getTopicUserExamList({
                data: params,
                success: res => {
                    this.setLoading(false)
                    this.active = 4
                    this.recordToSolveTheProblem = res.data
                    this.page3.total = res.data.pageinfo.rowCount
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res)
                }
            })
        },
        activeNamesChange(index, i) {
            console.log(this.chapterPractice.bankinfolist[index])
            console.log(index, i)
        },
        activeNamesItemChange(index, i) {

            console.log(this.chapterPractice.bankinfolist[index].activeNames.indexOf(i))
            console.log(index, i)
        },
        ...mapActions([
            'setLoading',
            'setLoginPop'
        ])
    },
    computed: {
        ...mapGetters([
            'topicQuesBankConfiguration',
            'topicQuesBankSectionConfiguration',
            'user',
            'domainlist',
            'domainInfo'
        ])
    },
    watch: {},
    components: {
        Page,
        clockIn
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .StartTheTopic {
        .subjectBox {
            background: #fff;
            height: 60px;
            display: flex;
            align-items: center;
            padding-left: 20px;
            position: relative;
            .title {
                font-size: 18px;
                color: #333333;
                font-weight: bold;
                margin-right: 14px;
            }
            .changeBox {
                width: 100px;
                height: 32px;
                // border: 1px solid #E5E5E5;
                color: #999999;
                font-size: 14px;
                position: relative;
                &:hover {}
                .btn {
                    width: 100px;
                    height: 32px;
                    height: 32px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #E5E5E5;
                    border-radius: 4px;
                    font-size: 14px;
                    img {
                        margin-right: 4px;
                    }
                    &:hover {
                        color: #409EFF;
                        border-color: #409EFF;
                    }
                }
            }
            .changeListBox {
                position: absolute;
                z-index: 11;
                top: 60px;
                left: 0px;
                width: 430px;
                box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
                height: 0;
                overflow: hidden;
                transition: height 0.3s;
                display: flex;
                .codeList {
                    width: 136px;
                    background: #fff;
                    overflow-x: hidden;
                    .innerBox {
                        max-height: 118px;
                        overflow-y: scroll;
                        width: 154px;
                        .item {
                            height: 40px;
                            line-height: 40px;
                            padding-left: 20px;
                            font-size: 12px;
                            cursor: pointer;
                        }
                        .item:hover {
                            background: #F5F7FA;
                            color: #409EFF;
                        }
                        .item.active {
                            color: #409EFF;
                            background: #F5F7FA;
                        }
                    }
                }
                .listBox {
                    background: #fff;
                    width: 295px;
                    .innerBox {
                        max-height: 118px;
                        width: 310px;
                        overflow-y: scroll;
                        .item {
                            line-height: 40px;
                            padding-left: 25px;
                            cursor: pointer;
                            font-size: 12px;
                        }
                        .item.active {
                            background: #E1F0FF;
                            color: #409EFF;
                        }
                        .item:hover {
                            background: #E1F0FF;
                            color: #409EFF;
                        }
                    }
                    
                }
                &.showlistBox {
                    // height: 118px;
                    height: auto;
                }
            }
            .clock_in {
                flex: 1;
                display: flex;
                justify-content: flex-end;
                img {
                    width: 130px;
                    height: 52px;
                    cursor: pointer;
                    position: relative;
                    top: 0;
                    transition: top 0.3s;
                    &:hover {
                        top: -4px;
                    }
                }
            }
        }
        .menuBox {
            display: flex;
            align-items: center;
            margin-top: 20px;
            background: #fff;
            .menuItem {
                flex: 1;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 12px 0;
                font-size: 14px;
                cursor: pointer;
                .box {
                    width: 30px;
                    height: 30px;
                    position: relative;
                    overflow: hidden;
                    margin-bottom: 6px;
                    .imgBox {
                        margin-bottom: 6px;
                        position: absolute;
                        transition: all 0.3s;
                        z-index: 10;
                        top: -40px;
                        .img1 {
                            margin-bottom: 10px;
                        }
                        &.show {
                            top: 0px;
                        }
                    }
                }
                .active {
                    color: #409EFF;
                }
                &.menuItemActive {
                    background: #F4FAFF;
                    border-bottom: 3px solid #409EFF;
                }
                &:hover {
                    background: #F4FAFF;
                    color: #409EFF;
                    .imgBox {
                        top: 0px;
                    }
                }
            }
        }
        .datatype1 {
            margin-top: 20px;
            background: #fff;
            padding: 20px 30px 70px;
            .titleBox {
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: #F8F8F8;
                height: 40px;
                font-size: 14px;
                color: #333333;
                .left {
                    text-indent: 172px;
                    font-weight: bold;
                }
                .right {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-right: 130px;
                    .accuracy {
                        font-weight: bold;
                        margin-right: 50px;
                    }
                    .count {
                        font-weight: bold;
                    }
                }
            }
            .outside {
                .outsideItem {
                    .el-collapse-item__header {
                        border-bottom: 1px solid #E5E5E5;
                        height: 56px;
                    }
                    .el-collapse-item__wrap {
                        border-bottom: none;
                        .el-collapse-item__content {
                            padding-bottom: 0;
                        }
                    }
                    .itemTitle {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        img {
                            margin-right: 12px;
                        }
                        .taskname {
                            margin-left: 34px;
                        }
                    }
                    .el-collapse-item__arrow {
                        display: none;
                    }
                    .subjectItem {
                        padding-left: 32px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 56px;
                        border-bottom: 1px solid #E5E5E5;
                        font-size: 14px;
                        .taskname {
                            flex: 1;
                            max-width: 400px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-size: 14px;
                        }
                        &:hover {
                            background: #F5F7FA;
                        }
                        .right {
                            display: flex;
                            align-items: center;
                            .accuracy {
                                width: 42px;
                                color: #999999;
                                text-align: center;
                            }
                            .count {
                                width: 64px;
                                text-align: center;
                                margin-left: 50px;
                                color: #999999;
                            }
                            .btn {
                                width: 80px;
                                margin-left: 50px;
                                cursor: pointer;
                                .continue {
                                    width: 80px;
                                    height: 32px;
                                    border: 3px solid #FFECD4;
                                    background: #F18B05;
                                    color: #fff;
                                    text-align: center;
                                    line-height: 26px;
                                    box-sizing: border-box;
                                    font-size: 14px;
                                    border-radius: 4px;
                                }
                                .doExercise {
                                    width: 80px;
                                    height: 32px;
                                    border: 3px solid #DFECFD;
                                    background: #409EFF;
                                    color: #fff;
                                    text-align: center;
                                    line-height: 26px;
                                    box-sizing: border-box;
                                    font-size: 14px;
                                    border-radius: 4px;
                                }
                            }
                        }
                    }
                    .inside {
                        border: none;
                        // padding-left: 26px;
                        .el-collapse-item__header {
                            border: none;
                            // margin-left: 26px;
                        }
                        .itemTitle {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            border-bottom: 1px solid #E5E5E5;
                            padding-left: 26px;
                            .left {
                                display: flex;
                                align-items: center;
                                .childrenlist {
                                    margin-left: 2px;
                                }
                            }
                            .right {
                                display: flex;
                                align-items: center;
                                .accuracy {
                                    width: 42px;
                                    color: #999999;
                                    text-align: center;
                                }
                                .count {
                                    width: 64px;
                                    text-align: center;
                                    margin-left: 50px;
                                    color: #999999;
                                }
                                .btn {
                                    width: 80px;
                                    margin-left: 50px;
                                    cursor: pointer;
                                    .continue {
                                        width: 80px;
                                        height: 32px;
                                        border: 3px solid #FFECD4;
                                        background: #F18B05;
                                        color: #fff;
                                        text-align: center;
                                        line-height: 26px;
                                        box-sizing: border-box;
                                        font-size: 14px;
                                        border-radius: 4px;
                                    }
                                    .doExercise {
                                        width: 80px;
                                        height: 32px;
                                        border: 3px solid #DFECFD;
                                        background: #409EFF;
                                        color: #fff;
                                        text-align: center;
                                        line-height: 26px;
                                        box-sizing: border-box;
                                        font-size: 14px;
                                        border-radius: 4px;
                                    }
                                }
                            }
                        }
                        .subjectItem {
                            padding-left: 73px;
                        }
                    }
                }
            }
        }
        .datatype2 {
            margin-top: 20px;
            background: #fff;
            padding: 20px 30px;
            .item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 80px;
                padding: 0 10px;
                border-bottom: 1px solid #E5E5E5;
                .leftMsg {
                    display: flex;
                    align-items: center;
                    .img {
                        margin-right: 12px;
                        width: 34px;
                        height: 34px;
                        img {
                            width: 34px;
                            height: 34px;
                        }
                    }
                    .textBox {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 34px;
                        .name {
                            font-size: 16px;
                            color: #333333;
                            margin-bottom: 6px;
                        }
                        .count {
                            font-size: 12px;
                            color: #999999;
                            .examcount {
                                margin-right: 10px;
                            }
                        }
                    }
                }
                .rightBtn {
                    width: 80px;
                    margin-left: 50px;
                    cursor: pointer;
                    .continue {
                        width: 80px;
                        height: 32px;
                        border: 3px solid #FFECD4;
                        background: #F18B05;
                        color: #fff;
                        text-align: center;
                        line-height: 26px;
                        box-sizing: border-box;
                        font-size: 14px;
                        border-radius: 4px;
                    }
                    .doExercise {
                        width: 80px;
                        height: 32px;
                        border: 3px solid #DFECFD;
                        background: #409EFF;
                        color: #fff;
                        text-align: center;
                        line-height: 26px;
                        box-sizing: border-box;
                        font-size: 14px;
                        border-radius: 4px;
                    }
                }
                &:hover {
                    background: #F5F7FA;
                    .textBox {
                        .name {
                            color: #409EFF;
                        }
                    }
                }
            }
        }
        .datatype3 {
            margin-top: 20px;
            background: #fff;
            padding: 20px 30px;
            .item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 70px;
                border-bottom: 1px solid #E5E5E5;
                .leftMsg {
                    .typeName {
                        display: flex;
                        align-items: center;
                        .type {
                            font-size: 14px;
                            color: #409EFF;
                            margin-right: 5px;
                        }
                        .name {
                            font-size: 14px;
                        }
                    }
                    .timeCount {
                        font-size: 12px;
                        color: #999999;
                        margin-top: 8px;
                        .time {
                            margin-right: 5px;
                        }
                    }
                }
                .rightBtn {
                    display: flex;
                    align-items: center;
                    .text {
                        font-size: 12px;
                        color: #999999;
                        margin-right: 20px;
                        &.check {
                            cursor: pointer;
                            &:hover {
                                color: #409EFF;
                            }
                        }
                    }
                    .continue {
                        width: 80px;
                        height: 32px;
                        border: 3px solid #FFECD4;
                        background: #F18B05;
                        color: #fff;
                        text-align: center;
                        line-height: 26px;
                        box-sizing: border-box;
                        font-size: 14px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    .doExercise {
                        width: 80px;
                        height: 32px;
                        border: 3px solid #DFECFD;
                        background: #409EFF;
                        color: #fff;
                        text-align: center;
                        line-height: 26px;
                        box-sizing: border-box;
                        font-size: 14px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                }
            }
        }
        .noData {
            padding: 88px 0 122px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img {
                margin-bottom: 20px;
                // width: 200px;
                height: 96px;
            }
            p {
                font-size: 14px;
                color: #CADAEE;
            }
        }
    }
</style>